// extracted by mini-css-extract-plugin
export default {"empty":"Index_empty__4oBkp","button":"Index_button__yFub0","logout":"Index_logout__HrF8l"};